<template>
	<div class="grid grid-cols-2 gap-3">
		<form-search :type="search" @select="structureSelect" :replaceOnSelect="true" class="col-span-2"> </form-search>
		<form-select
			:items="statut"
			prefix="Statut : "
			placeholder="Statut"
			@valueChange="form.status = $event"
			:value="form.status"
			class="lg:col-span-1 col-span-2">
			<template v-slot:icon>
				<i class="fas fa-fw fa-caret-down"></i>
			</template>
		</form-select>
		<form-select
			:items="services"
			prefix="Services : "
			placeholder="Service"
			@valueChange="form.service = $event"
			:value="form.service"
			class="lg:col-span-1 col-span-2">
			<template v-slot:icon>
				<i class="fas fa-fw fa-caret-down"></i>
			</template>
		</form-select>
		<ui-button @click="$emit('send', form)" :loading="loading" class="col-span-2">
			<template v-slot:icon>
				<i class="fas fa-circle-plus"></i>
			</template>
			<template v-slot:text>Ajouter</template>
		</ui-button>
	</div>
</template>

<script setup>
	import { ref, computed } from 'vue';
	import { usePage } from '@inertiajs/vue3';

	const page = usePage();

	const props = defineProps({
		// Ce que nous recherchons comme cible
		search: {
			type: String,
			default: 'structure',
		},
		// Ce que nous recherchons en termes de statut
		status: {
			type: String,
			default: 'structure',
		},
		// Ce que nous recherchons en termes de service
		service: {
			type: String,
			default: '',
		},
		loading: {
			type: Boolean,
			default: false,
		},
	});

	const emit = defineEmits(['send']);

	const form = ref({
		target: null,
		status: null,
		service: null,
		structureRaw: null,
	});

	const statut = computed(() => {
		return Object.values(page.props.str.statuses)
			.filter((status) => props.status === status.type)
			.map((status) => ({
				value: status.id,
				name: status.name,
			}));
	});

	const services = computed(() => {
		return Object.values(page.props.str.statuses)
			.filter((service) => props.service === service.type)
			.map((service) => ({
				value: service.id,
				name: service.name,
			}));
	});

	const structureSelect = (structure) => {
		form.value.target = structure.id;
		form.value.structureRaw = structure;
	};
</script>
